import ViewColumnOutlinedIcon from '@mui/icons-material/ViewColumnOutlined';
import Box from '@mui/material/Box';
import MuiButton from '@mui/material/Button';
import { alpha, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

export interface PickTaskListHeaderProps {
  total: number;
  onColumnsClick: () => void;
}

// On-dark (navy `v4.sidebar`) toolbar button: white text with translucent-white
// border/hover, expressed via theme tokens rather than raw hex/rgba.
const toolbarButtonSx = (theme: Theme) => ({
  textTransform: 'none' as const,
  fontSize: '12px',
  color: theme.palette.common.white,
  borderColor: alpha(theme.palette.common.white, 0.3),
  bgcolor: 'transparent',
  py: 0.25,
  '&:hover': {
    borderColor: theme.palette.common.white,
    bgcolor: alpha(theme.palette.common.white, 0.08),
  },
});

export const PickTaskListHeader: React.FC<PickTaskListHeaderProps> = ({
  total,
  onColumnsClick,
}) => (
  <Box
    component="header"
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      bgcolor: 'v4.sidebar',
      color: 'common.white',
      px: '20px',
      py: '12px',
      flexWrap: 'wrap',
      gap: 1,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
      <Typography sx={{ fontSize: '14px', fontWeight: 700, color: 'common.white' }}>
        Pick Tasks
      </Typography>
      {total > 0 && (
        <Box
          component="span"
          sx={(theme) => ({
            fontSize: '11px',
            color: alpha(theme.palette.common.white, 0.85),
            fontWeight: 400,
            bgcolor: alpha(theme.palette.common.white, 0.12),
            px: 1,
            py: '2px',
            borderRadius: '10px',
          })}
        >
          {total.toLocaleString()} results
        </Box>
      )}
    </Box>
    <Box sx={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
      <MuiButton
        variant="outlined"
        size="small"
        startIcon={<ViewColumnOutlinedIcon sx={{ fontSize: 14 }} />}
        onClick={onColumnsClick}
        sx={toolbarButtonSx}
      >
        Columns
      </MuiButton>
    </Box>
  </Box>
);
